import cx from 'classnames'

import { useThemeContext } from 'theme/themeProvider'

import classes from './styles.module.scss'

type Props = {
  title: string
}

export default function TitleWithDivider({ title }: Props) {
  const { isDarkMode } = useThemeContext()

  return (
    <div className={cx(classes.root, isDarkMode ? classes.dark : classes.light)}>
      <h3 className={classes.text}>{title}</h3>
      <div className={cx(classes.divider)} />
    </div>
  )
}
